import { FormattedMessage } from 'react-intl';
import { VStack } from '../sgBootstrapReactWrapper/VStack';

type Props = {
  id?: string;
};

const LoadingMessage = ({ id = 'loadInProgress' }: Props) => {
  return (
    <VStack className="px-16px py-12px">
      <FormattedMessage id={id} />
      <div className="blinker" data-e2e="blinker-loading" />
    </VStack>
  );
};

export default LoadingMessage;
